import React from 'react';
import SmartDialog from "../SmartDialog";
import {AutoSizer, Grid} from "react-virtualized";
import TTLProxy from "../../common/TTLAsyncProxy";
import {WalletEndpoints} from "../../common/ProxyEndpoints";
import Utils from "../../common/Utils";
import HTML from '../../common/HtmlHelpers';
import PropTypes from 'prop-types';
import MDProgress from 'react-md-progress-bar';
import {Button} from "reactstrap";
import AddWalletDialog from "./AddWalletDialog";
import Providers from './Providers';

/**
 * Wallet Management Dialog
 */
class WalletManagement extends React.Component {

    static propTypes = {
        colCount: PropTypes.number
    };

    static defaultProps = {
        colCount: 4
    };

    constructor(props){
        super(props);
        this.state = WalletManagement.getInitialState();
        this.renderWalletItem = this.renderWalletItem.bind(this);
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState(state){

        return {
            wallets: [],
            error: null,
            isBusy: false,
            user: state ? state.user : null
        };

    }

    show(user = null){

        this.setState(WalletManagement.getInitialState({ user }),() => {

            this._dlg.show();

            return this.loadState();

        });
    }

    async loadState(){

        const { user } = this.state;
        const proxy = this.proxy;

        this.setState({ isBusy: true });

        try{

            const res = await proxy.processRequest(user ? WalletEndpoints.getWalletsForUser(user.id) : WalletEndpoints.getMyWallets());

            this.setState({
                wallets: res.getPayload()
            });

        }
        catch (e) {

            let msg = Utils.getResponseError(e);

            //  toast warning
            HTML.toastWarning(msg);

            this.setState({
                error: msg
            });

        }
        finally {

            this.setState({
                isBusy: false
            });

        }

    }

    renderWalletItem({ columnIndex, key, rowIndex, style }){

        const { wallets } = this.state;
        const { colCount } = this.props;
        const linearIndex = (rowIndex  * colCount)  + columnIndex;
        const item = wallets[linearIndex];
        if(item === undefined || Providers.length === 0)
            return;

        const providerInstance = Providers.find(x => x.provider === item.provider);

        return (<div key={key} style={style} className="p-3">
            {providerInstance.walletItemRender(item,{ logo: providerInstance.logo , actions:
                    {

                        refresh: () => this.loadState(),

                        enable: async () => {

                            const proxy = this.proxy;

                            try {

                                const res = await proxy.processRequest(WalletEndpoints.updateWallet(item.id,{
                                    enabled: true
                                }));

                                if(res.ok){
                                    HTML.toastSuccess('Wallet enabled successfully');
                                    return this.loadState();
                                }

                            }
                            catch (e) {
                                HTML.toastError(Utils.getResponseError(e));
                            }


                        },

                        disable: async () => {

                            const proxy = this.proxy;

                            try {

                                const res = await proxy.processRequest(WalletEndpoints.updateWallet(item.id,{
                                    enabled: false
                                }));

                                if(res.ok){
                                    HTML.toastSuccess('Wallet disabled successfully');
                                    return this.loadState();
                                }

                            }
                            catch (e) {
                                HTML.toastError(Utils.getResponseError(e));
                            }

                        },

                        setDefault: async () => {

                            const proxy = this.proxy;

                            try {

                                const res = await proxy.processRequest(WalletEndpoints.updateWallet(item.id,{
                                    is_default: true
                                }));

                                if(res.ok){
                                    HTML.toastSuccess('Default wallet changed successfully');
                                    return this.loadState();
                                }

                            }
                            catch (e) {

                                HTML.toastError(Utils.getResponseError(e));
                            }
                        }

                    }
            })}
        </div>);

    }

    render(){

        const { isBusy , wallets ,  user  } = this.state;

        return <SmartDialog ref={r => this._dlg = r} title={<span><i className="fa fa-credit-card"/> Manage Wallets</span>} large>

            <AutoSizer disableHeight>
                {({ width }) => (<Grid cellRenderer={this.renderWalletItem}
                                        columnCount={this.props.colCount}
                                        columnWidth={256}
                                        height={380}
                                        noContentRenderer={() => <div className="text-center mt-4">
                                            <i className="fa fa-2x fa-smile-o"/>
                                            <p>Oops, there aren't any wallets here</p>
                                            <Button style={{ color: "green" }} color="link" outline onClick={() => this._addWallet.show(user)}><i className="fa fa-plus"/> Create Wallet</Button>
                                        </div> }
                                        rowCount={Math.ceil(wallets.length / this.props.colCount)}
                                        rowHeight={260}
                                        width={width}/>)}
            </AutoSizer>

            <hr/>

            {isBusy && <MDProgress show/>}

            <div className="clearfix">

                <div className="pull-right">
                    <Button color="green" onClick={() => this._addWallet.show(user)}><i className="fa fa-plus"/> Add Wallet</Button>
                </div>

            </div>

            <AddWalletDialog ref={r => this._addWallet = r}
                             onCreateWallet={() => this.loadState()}/>

        </SmartDialog>
    }

}

export default WalletManagement;



// WEBPACK FOOTER //
// ./src/components/WalletManagement/WalletManagement.js